// add new team
export const SETUP_ORGCHARTSET_NEW_DEPARTMENT_NAME = 'SETUP_ORGCHARTSET_NEW_DEPARTMENT_NAME';
export const SETUP_ORGCHARTRESET_NEW_DEPARMENT = 'SETUP_ORGCHARTRESET_NEW_DEPARMENT';

// tree
export const SETUP_ORGCHARTSET_SELECTED_DEPARTMENT = 'SETUP_ORGCHARTSET_SELECTED_DEPARTMENT';

// user
export const SETUP_ORGCHARTSET_USER = 'SETUP_ORGCHARTSET_USER';
export const SETUP_ORGCHARTSET_SELECT_USER = 'SETUP_ORGCHARTSET_SELECT_USER';

// sort team tree
export const SETUP_ORGCHARTSET_SORTING_TEAM = 'SETUP_ORGCHARTSET_SORTING_TEAM';

// ui
export const SETUP_ORGCHARTSET_ADD_VISIBLE = 'SETUP_ORGCHARTSET_ADD_VISIBLE';
export const SETUP_ORGCHARTSET_SORTABLE_VIEW_VISIBLE = 'SETUP_ORGCHARTSET_SORTABLE_VIEW_VISIBLE';
export const SETUP_ORGCHARTSET_SELECTED_USER_TEAM_DIALOG_VISIBLE = 'SETUP_ORGCHARTSET_SELECTED_USER_TEAM_DIALOG_VISIBLE';





// WEBPACK FOOTER //
// ./src/views/Setup/OrganisationChart/flow/actionType.js